import { AlertTypes } from '@/plugins/alerts_types'
import { notification, unmask } from '../plugins/helpers'

export default {
  methods: {
    async verificaSeCpfCnpjEIgual (cpf_ou_cnpj, id_usuario_erp) {
      const cpf_cnpj_usuario_logado = await this.getCpfCnpjUsuarioLogado(id_usuario_erp)
      try {
        return unmask(cpf_ou_cnpj) === cpf_cnpj_usuario_logado
      } catch {
        // eslint-disable-next-line no-unused-expressions
        () => {
        // Não exibir em tela o erro !!
        }
      }
    },
    async getCpfCnpjUsuarioLogado (id_usuario_erp) {
      // eslint-disable-next-line no-return-await
      return await this.$http.get('/usuarios/' + id_usuario_erp)
        .then(result => {
          if (result.data) {
            return result.data.cpf
          }
        })
        .catch((ex) => {
          // Não exibir em tela o erro!
        })
    },
    verifyIfSomeInputIsEqualUserLoggedData (numero_da_proposta = 'inexistente', email, telefone, celular, enderecos) {
      try {
        // eslint-disable-next-line no-self-assign
        numero_da_proposta == null ? numero_da_proposta = 'inexistente' : numero_da_proposta = numero_da_proposta
        const dadosUsuarioLogado = this.$session.get('dados_usuario_logado')
        if (email && dadosUsuarioLogado.email_pessoa) {
          if (email.toLowerCase() === dadosUsuarioLogado.email_pessoa.toLowerCase()) {
            this.logBloqueio(numero_da_proposta, 'e-mail', email, dadosUsuarioLogado.email_pessoa)
            notification(AlertTypes.WARN, 'O email informado no cadastro pertence ao ao próprio usuário logado. Venda não permitida! Por favor, revise os dados inseridos.')
            return true
          }
        }
        if (telefone && dadosUsuarioLogado.telefones_pessoa) {
          const telefone_without_ddd = telefone.slice(5)
          let bloquear = false

          dadosUsuarioLogado.telefones_pessoa.forEach(telefones_do_usuario => {
            if (unmask(telefones_do_usuario.Telefone) === unmask(telefone) || unmask(telefones_do_usuario.Telefone) === unmask(telefone_without_ddd)) {
              if (!bloquear) {
                this.logBloqueio(numero_da_proposta, 'telefone', telefone, telefones_do_usuario.Telefone)
                notification(AlertTypes.WARN, 'O telefone informado no cadastro pertence ao ao próprio usuário logado. Venda não permitida! Por favor, revise os dados inseridos.')
                bloquear = true
              }
            }
          })
          if (bloquear) {
            return true
          }
        }

        if (celular && dadosUsuarioLogado.telefones_pessoa) {
          const celular_without_ddd = celular.slice(5)
          let bloquear = false
          dadosUsuarioLogado.telefones_pessoa.forEach(telefones_do_usuario => {
            if (unmask(telefones_do_usuario.Telefone) === unmask(celular) || telefones_do_usuario.Telefone === unmask(celular_without_ddd)) {
              if (!bloquear) {
                this.logBloqueio(numero_da_proposta, 'celular', celular, telefones_do_usuario.Telefone)
                notification(AlertTypes.WARN, 'O celular informado no cadastro pertence ao ao próprio usuário logado. Venda não permitida! Por favor, revise os dados inseridos.')
                bloquear = true
              }
            }
          })
          if (bloquear) {
            return true
          }
        }
        if (enderecos && dadosUsuarioLogado.enderecos_pessoa) {
          let bloquear = false
          dadosUsuarioLogado.enderecos_pessoa.forEach(enderecos_do_usuario => {
            enderecos.forEach(enderecos_do_input => {
              const cepIgual = unmask(enderecos_do_usuario.CEP) === unmask(enderecos_do_input.cep)
              const numeroIgual = enderecos_do_input.numero === enderecos_do_usuario.NO_Endereco
              const complementoUsuario = enderecos_do_usuario.Complemento || ''
              const complementoInput = enderecos_do_input.complemento || ''
              const complementoIgual = complementoUsuario.trim().toLowerCase() === complementoInput.trim().toLowerCase()

              if (cepIgual && numeroIgual && complementoIgual) {
                if (!bloquear) {
                  this.logBloqueio(numero_da_proposta, 'cep', enderecos_do_input.cep, enderecos_do_usuario.CEP)
                  notification(AlertTypes.WARN, 'O endereço informado no cadastro pertence ao ao próprio usuário logado. Venda não permitida! Por favor, revise os dados inseridos.')
                  bloquear = true
                }
              }
            })
          })
          if (bloquear) {
            return true
          }
        }

        return false
      } catch (e) {
        return false
        // Não exibir em tela o erro!
      }
    },
    logBloqueio (numeroDaProposta, motivoBloqueio, informacaoIgual, informacaoNewcon) {
      this.$http.post('/log_bloqueio',
        {
          'numeroDaProposta': numeroDaProposta,
          'motivoBloqueio': motivoBloqueio,
          'informacaoIgual': informacaoIgual,
          'informacaoNewcon': informacaoNewcon,
          options: {
            silent: true
          }
        })
    }
  }
}
